import { render } from "./TailwindButton.vue?vue&type=template&id=b621d2ac"
import script from "./TailwindButton.vue?vue&type=script&lang=js"
export * from "./TailwindButton.vue?vue&type=script&lang=js"

import "./TailwindButton.vue?vue&type=style&index=0&id=b621d2ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__